import React, { FC, useContext } from "react";
import { ThemeContext } from "styled-components";
import Image from "next/image";
import getConfig from "next/config";
import { getCloudflareLoader } from "../../helpers/cloudflareImages";
import { getTenantLogoBackgroundColor } from "../../helpers/theme";
import { StyledBackground } from "./index.styled";

interface BorderedTenantLogoProps {
  logoAlt?: string;
  logoSrc: string;
  tenantId: string;
  small?: boolean;
  isDisabled?: boolean;
}

const { publicRuntimeConfig } = getConfig();

export const BorderedTenantLogo: FC<BorderedTenantLogoProps> = ({
  logoAlt,
  logoSrc,
  tenantId,
  small,
  isDisabled,
}) => {
  const theme = useContext(ThemeContext);
  const backgroundColor = getTenantLogoBackgroundColor(
    tenantId,
    theme.color.primary
  );

  return (
    <StyledBackground
      backgroundColor={backgroundColor}
      small={small}
      isDisabled={isDisabled}
    >
      <Image
        src={logoSrc || "/"}
        alt={logoAlt || "Shop Logo"}
        loader={getCloudflareLoader(publicRuntimeConfig.cdn)}
        fill
        // double largest width for retina screens
        sizes="140px"
        style={{
          objectFit: "contain",
        }}
      />
    </StyledBackground>
  );
};
